var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83329 2.83333C4.99067 2.6235 5.23766 2.5 5.49996 2.5H15.5C15.7623 2.5 16.0092 2.6235 16.1666 2.83333L18.6666 6.16667C18.7748 6.31091 18.8333 6.48636 18.8333 6.66667V7.5C18.8333 8.34532 18.5179 9.11777 18 9.70479V16.6667C18 17.1269 17.6269 17.5 17.1666 17.5H3.83329C3.37306 17.5 2.99996 17.1269 2.99996 16.6667V9.70479C2.48206 9.11777 2.16663 8.34532 2.16663 7.5V6.66667C2.16663 6.48636 2.22511 6.31091 2.33329 6.16667L4.83329 2.83333ZM4.66663 10.7281V15.8333H7.99996L7.99997 14.1667C7.99997 12.7859 9.11925 11.6667 10.5 11.6667C11.8807 11.6667 13 12.786 13 14.1667L13 15.8333H16.3333V10.7281C16.0668 10.7968 15.7876 10.8333 15.5 10.8333C14.5044 10.8333 13.6107 10.3969 13 9.70485C12.3892 10.3969 11.4955 10.8333 10.5 10.8333C9.50438 10.8333 8.61075 10.3969 7.99996 9.70485C7.38917 10.3969 6.49554 10.8333 5.49996 10.8333C5.21237 10.8333 4.93309 10.7968 4.66663 10.7281Z",
    fill: "currentColor "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/market-icon.13bff58dac02eb852ed31270c8bef95c.svg";
export { ForwardRef as ReactComponent };